import React, { useState } from "react";
import { OverViewInput } from "../../../config/allWorkout";
import { InputField } from "../../../components/common/InputField";
import UploadedBanner from "../../../components/common/UploadBanner";
import { useMediaStore } from "../../../store";
import { SearchableSelectField } from "../../../components/common/SearchableSelectField";

const OverView = ({ exerciseData, disabled, weekIndex, dayIndex, setUploadedJson }) => {
  const { imageUrls, videoUrls } = useMediaStore();
  const [formData, setFormData] = useState(exerciseData || {});

  const getValueOrPlaceholder = (value, placeholder) => {
    return value ? value : placeholder;
  };

  const handleFieldChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    setUploadedJson((prev) => {
      let previous = { ...prev };
      // Ensure we update the correct category
      previous.weeks[weekIndex]['days'][dayIndex][key] = value;
      return previous;
    });
  };

  const handleSelectChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setUploadedJson((prev) => {
      let previous = { ...prev };
      // Ensure we update the correct category
      previous.weeks[weekIndex]['days'][dayIndex][key] = value;
      return previous;
    });
  };

  return (
    <div className="row">
      <div className="col-sm-8">
        <div className="row separator">
          {OverViewInput?.map((fieldConfig, index) => (
            <div className="col-sm-6" key={index}>
              <div className="mb-3">
                <InputField
                  label={fieldConfig.label}
                  type="text"
                  className="form-control"
                  id={fieldConfig.id}
                  placeholder={fieldConfig.placeholder}
                  value={getValueOrPlaceholder(
                    formData?.[fieldConfig.valueKey],
                    fieldConfig.defaultValue
                  )}
                  onChange={(e) =>
                    handleFieldChange(fieldConfig.valueKey, e.target.value)
                  }
                  disabled={fieldConfig.valueKey === 'day_name' ? false :  disabled}
                />
              </div>
            </div>
          ))}

          <div className="col-sm-6 mb-3">
            <SearchableSelectField
              key={`image${ weekIndex}${dayIndex}`}
              label={'Image Name'}
              id={`image${ weekIndex}${dayIndex}`}
              options={imageUrls}
              value={formData?.['day_banner_image']}
              
              onChange={(value) =>
                handleSelectChange("day_banner_image", value)
              }
            />
          </div>
         
          

          <div className="col-sm-6 mb-3">
          <SearchableSelectField
            key={`video${ weekIndex}${dayIndex}`}
            label={'Video Name'}
            id={`intro_video${ weekIndex}${dayIndex}`}
            options={videoUrls}
            value={formData?.['intro_video']}
            onChange={(value) =>
              handleSelectChange("intro_video", value)
            }
          />
          </div>


         
          
        </div>
      </div>
      <div className="col-sm-4 mb-3">
        <UploadedBanner defaultImage={formData?.day_banner_image} />
      </div>
    </div>
  );
};

export default OverView;
